import {getLanguageChoices} from "@/helpers/lists";

class Metadata {
  constructor() {
    this.id = 0;
    this.active = true;
  }

  static FromObj(obj) {
    let newObj = new Metadata();

    newObj.id = obj.id;
    newObj.active = obj.active;

    return newObj;
  }
}

class ManufactureMetadata extends Metadata {
  constructor() {
    super();

    this.name = '';

    this.subsystem = [];
    this.sleeve_color = [];

    this.sleeve_price = [];
    for (let lang of getLanguageChoices()) {
      this.sleeve_price.push({
        value: 0,
        currency: lang.value,
        icon: lang.icon
      });
    }
  }

  static FromObj(obj) {
    let metadata_obj = Object.assign(new ManufactureMetadata(), obj);
    return metadata_obj;
  }

  addSubsystem(sub_system_name) {
    let obj = {
      name: sub_system_name,
      active: true
    }
    this.subsystem.push(obj);
  }

  removeSubSystem(sub_system) {
    const index = this.subsystem.indexOf(sub_system);
    this.subsystem.splice(index, 1);
  }

  addSleeveColor(sleeve_color) {
    let obj = {
      name: sleeve_color,
      active: true
    }
    this.sleeve_color.push(obj);
  }
  removeSleeveColor(sleeve_item) {
    const index = this.sleeve_color.indexOf(sleeve_item);
    this.sleeve_color.splice(index, 1);
  }
}

export {
  Metadata,
  ManufactureMetadata
}
